import { ReactComponent as Eth } from "assets/icons/eth.svg";
import { ReactComponent as Invite } from "assets/icons/invite.svg";

import { useController } from "./Controller";
import { ComingSoon, Loading, Modal } from "components/commons";
import { useState } from "react";
import {
  DocumentDuplicateIcon,
  ArrowPathIcon,
  PaperAirplaneIcon,
  BanknotesIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import CopyToClipboard from "react-copy-to-clipboard";
import { Breadcum } from "components/commons/Breadcum";
import { usePrivy } from "@privy-io/react-auth";
import { Dialog } from "@headlessui/react";
import { formatAmount } from "utils/number/number";
import { formatEther, parseEther } from "@ethersproject/units";
import { isAddress } from "ethers/lib/utils";
function ProfileBalance() {
  const [isCopied, setIsCopied] = useState(false);
  const [inputAddress, setInputAddress] = useState("");
  const [inputAmount, setInputAmount] = useState("0");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenBuyEth, setIsOpenBuyEth] = useState<boolean>(false);

  const { exportWallet, sendTransaction } = usePrivy();

  const {
    data,
    isLoading,
    walletAddress,
    balance,
    tradingFeeEarned,
    portfolioValue,
  } = useController();

  const tiktokUserInfo = data?.tiktok_user_info;
  const avatar = tiktokUserInfo?.metadata?.avatar_300x300;
  const truncatedAddress =
    walletAddress &&
    `${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`;

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  const toggleModalBuyEth = () => {
    setIsOpenBuyEth(!isOpenBuyEth);
  };

  const handleWithdraw = async () => {
    const unsignedTx = {
      to: inputAddress,
      chainId: 8453,
      value: parseEther(inputAmount).toHexString(),
    };

    // Replace this with the text you'd like on your transaction modal
    const uiConfig = {
      header: "Withdraw ETH",
      description:
        "Transfer ETH from your fan.tech wallet to another wallet on Base",
      buttonText: "Confirm",
    };

    try {
      await sendTransaction(unsignedTx, uiConfig);
    } catch (error) {
      console.log(
        "🚀 ~ file: DepositEth.tsx:41 ~ handleCheckBalance ~ error:",
        error
      );
    }
  };

  return (
    <div className="flex-1 flex flex-col justify-between">
      <Breadcum title="My Balance" />

      <Modal isOpen={isOpenBuyEth} toggleModal={toggleModalBuyEth}>
        <Dialog.Title
          as="h3"
          className="text-lg font-normal leading-6 text-white text-center"
        >
          Buy ETH
        </Dialog.Title>
        <ComingSoon />
      </Modal>

      <Modal isOpen={isOpen} toggleModal={toggleModal}>
        <div className="flex flex-col justify-center items-center p-4 gap-4 w-full text-center">
          <Dialog.Title
            as="h3"
            className="text-lg font-normal leading-6 text-white"
          >
            Withdraw ETH
          </Dialog.Title>

          <p className="text-sm text-slate-300">
            Transfer ETH from your fan.tech wallet to another wallet on Base
          </p>

          <div className="w-full flex flex-col items-start gap-2">
            <label className="text-sm font-medium">Wallet address</label>
            <input
              placeholder="Your wallet address"
              className="w-full py-4 px-[14px] pr-10 border-2 border-slate-700 bg-transparent rounded-xl focus:outline-none text-slate-300 text-sm"
              value={inputAddress}
              onChange={(e) => {
                e.preventDefault();
                setInputAddress(e.currentTarget.value);
              }}
            />
          </div>

          <div className="w-full flex flex-col items-start gap-2">
            <label className="text-sm font-medium">Amount</label>
            <div className="flex gap-2 relative items-center mb-4 shadow-sm w-full">
              <input
                placeholder="0 ETH"
                className="w-full pl-4 py-[14px] pr-14 border-2 border-slate-700 bg-transparent rounded-xl focus:outline-none text-slate-300 text-sm"
                value={inputAmount}
                onChange={(e) => {
                  e.preventDefault();
                  setInputAmount(e.currentTarget.value);
                }}
                // onKeyDown={handleKeyDown}
              />

              <div className="absolute inset-y-0 right-0 py-[14px] px-3 cursor-pointer">
                <button
                  className="shadow-sm rounded-xl text-sm"
                  onClick={(e) => {
                    setInputAmount(formatEther(balance));
                  }}
                >
                  MAX
                </button>
              </div>
            </div>
          </div>

          <div className="text text-[#CBD5E1] text-sm flex justify-start w-full">
            <div>Your balance: {formatAmount(balance ?? "0", 18, 4)} ETH</div>
          </div>

          <button
            className="rounded-xl btn w-full bg-secondary uppercase"
            disabled={
              !isAddress(inputAddress) || parseEther(inputAmount).gt(balance)
            }
            onClick={(e) => {
              e.preventDefault();
              handleWithdraw();
            }}
          >
            Transfer
          </button>
        </div>
      </Modal>

      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="mt-10">
            <div className="border-b border-gray-800 p-4">
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <img
                    className="border w-16 h-16 rounded-full border-slate-700"
                    alt="avatar"
                    src={avatar}
                  />
                  <div className="space-y-1 flex-1">
                    <div>{tiktokUserInfo?.nickname}</div>{" "}
                    <div className="text-sm text-slate-500 font-normal">
                      {truncatedAddress}
                      <CopyToClipboard
                        text={walletAddress!}
                        onCopy={() => {
                          setIsCopied(true);
                        }}
                      >
                        <button>
                          <DocumentDuplicateIcon
                            className={`w-4 h-4 inline ml-1  ${
                              isCopied
                                ? "stroke-1 stroke-slate-500"
                                : "stroke-2 stroke-white"
                            }`}
                          />
                        </button>
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div className="space-y-1">
                    <div className="text-right">
                      {formatAmount(balance ?? "0", 18, 4)} ETH
                    </div>{" "}
                    <div className="text-right text-sm text-slate-500 font-normal">
                      Wallet balance{" "}
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
              <button
                className="px-3 py-[6px] border-2 border-gray-800 rounded-full text-sm font-normal text-slate-300"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <ArrowPathIcon className="w-4 inline mr-1 text-white" /> Sync
                profile data{" "}
              </button>
            </div>
            <div className="border-b border-gray-800 flex divide-x">
              <div className="w-full border-gray-800 text-sm text-slate-300 p-4">
                <div>Portfolio value</div>
                <div className="text-base text-white font-normal mt-1">
                  <Eth className="w-5 mr-1 inline" /> {portfolioValue ?? 0} ETH
                </div>
              </div>

              <div className="w-full border-gray-800 text-sm p-4 ">
                <div>Trading fees earned</div>
                <div className="text-base text-white font-normal mt-1">
                  <Eth className="w-5 mr-1 inline" /> {tradingFeeEarned} ETH
                </div>
              </div>
            </div>
            <div className="flex p-4 gap-4 pb-8 justify-center items-center ">
              <div className="w-full py-4 flex gap-4 flex-col justify-center items-center">
                <button
                  className="rounded-full w-12 h-12 bg-secondary flex justify-center items-center"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleModalBuyEth();
                  }}
                >
                  <BanknotesIcon className="w-6" />
                </button>
                <span className="text-sm text-slate-300">Buy ETH</span>
              </div>

              <div className="w-full py-4 flex gap-4 flex-col justify-center items-center">
                <button
                  className="rounded-full w-12 h-12 bg-secondary flex justify-center items-center"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleModal();
                  }}
                >
                  <PaperAirplaneIcon className="w-6" />
                </button>
                <span className="text-sm text-slate-300">Withdraw</span>
              </div>
            </div>
          </div>

          <div className="mx-4 mb-10">
            <button
              className="rounded-xl btn btn-outline border-2 border-gray-800 w-full uppercase"
              onClick={(e) => {
                e.preventDefault();
                exportWallet();
              }}
            >
              <span className="text-slate-300">Export Wallet</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export { ProfileBalance as default };
